import React from 'react'
import EveryOne from './EveryOne'

const EveryoneorderOne = () => {
  return (
    <>
   <table className='table-one-game'>
        <tr className='table-hd'>
          <td>Period</td>
          <td>User</td>
          <td>Select</td>
          <td>Point</td>
        </tr>
        <EveryOne/>
      </table>
    
    </>
  )
}

export default EveryoneorderOne